/**
 * Constants related to mediaquery sizing synchronization with Bootstrap
 */

/** Bootstrap xs are less than 575px (i.e. < 576) */
// No MIN_XS required as no lower limit
/** Bootstrap sm are 575px and up (i.e. >= 576) */
export const BOOTSTRAP_MIN_XS = 576;

/** Bootstrap md are Tablets 768px and Up (i.e. >= 768) */
export const BOOTSTRAP_MIN_SM = 768;

/** Bootstrap lg are Desktops 992px and Up (i.e. >= 992) */
export const BOOTSTRAP_MIN_MD = 992;

/** Bootstrap xl are Large Desktops 1200px and Up (i.e. >= 1200) */
export const BOOTSTRAP_MIN_LG = 1200;


/** Bootstrap xs are less than 575px (i.e. < 576) */
export const BOOTSTRAP_MAX_XS = 575.9;

/** Bootstrap sm are less than 768px (i.e. < 768) */
export const BOOTSTRAP_MAX_SM = 767.9;

/** Bootstrap md are less than 992px (i.e. < 992) */
export const BOOTSTRAP_MAX_MD = 991.9;

/** Bootstrap lg are less than 1200px (i.e. < 1200) */
export const BOOTSTRAP_MAX_LG = 1199.9;

/** Bootstrap lg are Large Desktops 1200px and Up (i.e. >= 1200) */
// No MAX_XL required as no upper limit



// WEBPACK FOOTER //
// ./src/constants/bootstrapResponsive.js